/*eslint-disable*/
import api from '../'

class WordsFieldApi {
    // get: /words-field/groups
    static getGroups (locale) {
        return api.axios.get('/words-field-reading-en/groups', {
            params: {
                locale
            }
        }).then(response => response.data.groups);
    }

    static getWords (params) {
        return api.axios.get('/words-field-reading-en/words', { params }).then(response => response.data);
    }
}

export default WordsFieldApi;
